import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const InvalidAddressDialog = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => {
  const { t } = useTranslation("orders", {
    keyPrefix: "modal.submitOrderInvalidAddress",
  });

  return (
    <Dialog open={isOpen}>
      <DialogTitle>{t("title")}</DialogTitle>
      <IconButton
        aria-label="Close"
        size="large"
        onClick={close}
        sx={{
          position: "absolute",
          right: 10,
          top: 15,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText>{t("description")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="primary">
          {t("ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidAddressDialog;
